import "core-js/stable";
import { oidcClient } from "./auth";

oidcClient.then((client) => {
    client
        .handleAuthentication()
        .then(async ({ shouldRender, state }) => {
            if (state?.finalRedirectUri) {
                window.location.href = state.finalRedirectUri;
            } else if (shouldRender) {
                import("./app").then(({ buildApp }) => buildApp());
            }
        })
        .catch(async (err) => {
            console.log(err);
            client.logout();
        });
});
